// 환경 변수에서 API 서버 URL 가져오기
export const API_SERVER = process.env.REACT_APP_API_SERVER || 'https://data-salon.basicfive.co.kr';

// 디버깅을 위한 로그
console.log('환경 변수 정보:', {
  NODE_ENV: process.env.NODE_ENV,
  API_SERVER: process.env.REACT_APP_API_SERVER,
});

// API 기본 URL 설정 (환경 변수에서 직접 가져옴)
export const API_BASE_URL = API_SERVER;

// 최종 API URL 로그
console.log('최종 API URL:', API_BASE_URL); 